<script>
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      avatar:"",
      certificate:"",
      description:null,
      id:"",
      name:"",
    }
  },
  methods: {
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || '';
    },
  }
}
</script>
<template>
  <el-dialog
    width="788px"
    :class="$style.dialogReservationJtails"
    :visible.sync="dialog2MixinVisible"
    append-to-body
    custom-class="isStyleBase"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogReservationJtails__title mb-4"> 美容師介紹 </div>
    <div class="row">
      <div class="col-md-5 col-12">
        <div
          class="dialogReservationJtails__img mb-5"
          :style="{ backgroundImage: `url('${ avatar || require('@assets/images/reservation/person_background.svg') }')` }"
        >
        </div>
      </div>
      <div class="col-md-7 col-12">
        <div
          class="mb-4"
        >
          <h3 class="dialogReservationJtails__subtitle mb-3">{{ name }}</h3>
          <div
            class="lh-lg text-gray-2 mb-2"
          >
            證照：{{certificate}}
          </div>
          <div class="lh-lg text-gray-2">
            專長： <div  v-text="specialty"></div>
          </div>
        </div>
        <div
          v-if="description"
          class="mt-4"
        >
          <h3 class="dialogReservationJtails__subtitle">個人介紹</h3>
          <div
            class="lh-lg"
            v-text="description"
          ></div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogReservationJtails {
  :global {
    .dialogReservationJtails {
      &__title {
        @extend %FontSerifWeightJtails;

        font-size: 1.313rem;
        text-align: center;
      }
      &__img {
        height: 170px;
        width: 170px;
        border-radius: 100%;
        margin: 0 auto;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
      &__subtitle {
        @extend %FontSerifWeightJtails;

        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
